export default "__VITE_ASSET__DI0wud1D__"